import React, { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import PrivateRoute from './components/PrivateRoute';
import SuperuserRoute from './components/SuperuserRoute';
import LegacyRoute from './components/LegacyRoute';
import Login from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import AcceptInvite from './pages/AcceptInvite';
import Profile from './pages/Profile';
import TrocarSenhaObrigatoria from './pages/TrocarSenhaObrigatoria';
import AppLayout from './layouts/AppLayout';
import Dashboard from './pages/Dashboard';
import PecasPage from './pages/PecasPage';
import EditorPage from './pages/EditorPage';
import LegacyIndividual from './pages/LegacyIndividual';
import ProductPage from './pages/ProductPage';
import LoteUpload from './components/LoteUpload';
import './App.css';
import ImportarPecas from './components/ImportarPecas/ImportarPecas';
import StepConverter from './components/StepConverter';
import RoteiroGerar from './components/RoteiroGerar/RoteiroGerar';
import RoutingQualityMetrics from './pages/RoutingQualityMetrics';
import AdminUsuarios from './components/AdminUsuarios/AdminUsuarios';
import AdminOperacoes from './components/AdminOperacoes/AdminOperacoes';
import AdminSetores from './components/AdminSetores/AdminSetores';
import Suporte from './components/Suporte/Suporte';
import Paletizacao from './components/Paletizacao/Paletizacao';
import useTelemetriaAcesso from './hooks/useTelemetriaAcesso';

function App() {
  useTelemetriaAcesso();

  // Habilita a transição suave de cores só depois do primeiro paint —
  // senão o load inicial (que já chega no tema certo via script
  // anti-FOUC em public/index.html) também seria animado.
  useEffect(() => {
    const raf = requestAnimationFrame(() => {
      document.documentElement.classList.add('cw-transitions-ready');
    });
    return () => cancelAnimationFrame(raf);
  }, []);

  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/accept-invite" element={<AcceptInvite />} />
      <Route
        path="/profile"
        element={
          <PrivateRoute>
            <Profile />
          </PrivateRoute>
        }
      />
      <Route
        path="/trocar-senha-obrigatoria"
        element={
          <PrivateRoute>
            <TrocarSenhaObrigatoria />
          </PrivateRoute>
        }
      />

      <Route
        path="/"
        element={
          <PrivateRoute>
            <AppLayout />
          </PrivateRoute>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="pecas" element={<PecasPage />} />
        <Route path="pecas/importar" element={<ImportarPecas />} />
        <Route path="produtos/:productId" element={<ProductPage />} />
        <Route path="roteiro" element={<RoteiroGerar />} />
        <Route path="roteiro/metricas" element={<RoutingQualityMetrics />} />
        <Route path="paletizacao" element={<Paletizacao />} />
        <Route path="editor" element={<EditorPage />} />
        <Route path="conversor-step" element={<StepConverter />} />
        <Route path="suporte" element={<Suporte />} />
        <Route
          path="admin/usuarios"
          element={
            <SuperuserRoute>
              <AdminUsuarios />
            </SuperuserRoute>
          }
        />
        <Route
          path="admin/operacoes"
          element={
            <SuperuserRoute>
              <AdminOperacoes />
            </SuperuserRoute>
          }
        />
        <Route
          path="admin/setores"
          element={
            <SuperuserRoute>
              <AdminSetores />
            </SuperuserRoute>
          }
        />
        <Route
          path="legado/individual"
          element={
            <LegacyRoute>
              <LegacyIndividual />
            </LegacyRoute>
          }
        />
        <Route
          path="legado/lote"
          element={
            <LegacyRoute>
              <LoteUpload />
            </LegacyRoute>
          }
        />
        <Route path="*" element={<Navigate to="/pecas" replace />} />
      </Route>
    </Routes>
  );
}

export default App;
